import {
  AdminSpinner,
  ArrowRed,
  BestPerformingLocationsEntity,
  Box,
  Div,
  getDashboardBestPerformingLocations,
  H5,
  Icon,
  lightTheme,
  ModalPortal,
  BestPerformingLocationComponent,
  BestPerformingPlaceholder,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

async function getBestPerformingLocations(
  page: number,
  bestPerformingLocations: BestPerformingLocationsEntity[] | null,
  setBestPerformingLocations: Dispatch<
    SetStateAction<BestPerformingLocationsEntity[] | null>
  >,
  hasMore: boolean,
  setHasMore: Dispatch<SetStateAction<boolean>>,
  setPage: Dispatch<SetStateAction<number>>,
  setLoading: Dispatch<SetStateAction<boolean>>
) {
  if (!hasMore) return;
  setLoading(true);

  const LIMIT = 10;

  try {
    const { data } = await getDashboardBestPerformingLocations({
      page,
      limit: LIMIT,
    });

    if (bestPerformingLocations === null) {
      setBestPerformingLocations(data.data);
    } else {
      setBestPerformingLocations((prev) => [...(prev || []), ...data.data]);
    }

    setHasMore(data.data.length === LIMIT);
    setPage(page + 1);
  } catch (error) {
    reportError(error);
  } finally {
    setLoading(false);
  }
}

export const BestPerformingLocationSection = () => {
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [bestPerformingLocations, setBestPerformingLocations] = useState<
    BestPerformingLocationsEntity[] | null
  >(null);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [ref, inView] = useInView();

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    // setBestPerformingLocations(null);
    getBestPerformingLocations(
      1,
      null,
      setBestPerformingLocations,
      true,
      setHasMore,
      setPage,
      setLoading
    );
  }, []);

  useEffect(() => {
    if (inView && hasMore) {
      getBestPerformingLocations(
        page,
        bestPerformingLocations,
        setBestPerformingLocations,
        hasMore,
        setHasMore,
        setPage,
        setLoadingMore
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <>
      <Box $p="16px 20px" $relative $overflow="hidden">
        {loading && <AdminSpinner small absolute creme />}
        {bestPerformingLocations?.length ? (
          <Icon
            $pointer
            style={{ position: 'absolute', right: 16, top: 16 }}
            onClick={() => setIsOpen(true)}
            color={lightTheme.lightGray}
          >
            <ArrowRed />
          </Icon>
        ) : null}
        <H5 $mb="16">Best Performing Locations</H5>

        {bestPerformingLocations?.slice(0, 5).map((item, index) => (
          <BestPerformingLocationComponent
            key={index}
            item={item}
            index={index}
          />
        ))}

        <BestPerformingPlaceholder
          length={bestPerformingLocations?.length || 0}
        />
      </Box>
      <ModalPortal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        backgroundColor={lightTheme.white}
        padding="24px"
        logo={false}
        width="600px"
        maxHeight="calc(65px * 10)"
        modalOverflow="hidden"
        titleWithExit={'Best Performing Locations'}
      >
        {loadingMore && <AdminSpinner small absolute />}

        {bestPerformingLocations?.map((item, index) => (
          <BestPerformingLocationComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
        <Div $height="20px" ref={ref}></Div>
      </ModalPortal>
    </>
  );
};
